// extracted by mini-css-extract-plugin
export default {"container":"style_container__4WaJg","min-height":"style_min-height__GJ5RQ","start":"style_start__Zngnl","column":"style_column__BstJc"};